// Legacy hardcoded image options. Preserved for backward compatibility.

export const LEGACY_IMAGE_OPTIONS = [
  { path: "main/concert_001.jpg", alias: "Generic Event" },
  // run group
  { path: "main/medium_run_group_001.jpeg", alias: "--Run Group--" },
  { path: "main/run_happy_hour_2024_03_20.jpg", alias: "Run Group Happy Hour" },
  { path: "main/trackrun01.png", alias: "Run Group Track" },
  { path: "main/trail_run_group_2025_April27a.jpg", alias: "Run Group Trail Hill" },
  { path: "main/17.jpg", alias: "Run Group Neptune Big Friend Group Alec Adam" },
  { path: "main/32.jpg", alias: "Run Group AM Beach Coffee Dogs" },
  { path: "main/33.jpg", alias: "Run Group AM Beach Girlfriends" },
  { path: "main/36.jpg", alias: "Run Group AM Beach Group" },

  // pickleball group
  { path: "main/medium_pickleball_001.jpeg", alias: "--Pickleball Jarboe Line--" },
  { path: "main/38.jpg", alias: "Pickleball Jarboe Line OGs" },
  { path: "main/31.jpg", alias: "Pickleball Jarboe Palm Trees OGs" },
  { path: "main/2.jpg", alias: "Pickleball Group Jarboe Courts" },
  { path: "main/pickleball_group_bump_2025_April28a.jpeg", alias: "Pickleball Fort Family Group Bump" },
  { path: "main/21.jpg", alias: "Pickleball Veterans Spindrift Cheers" },
  { path: "main/22.jpg", alias: "Pickleball Veterans Big Group" },
  { path: "main/37.jpg", alias: "Pickleball Jarboe OGs Winter" },
  { path: "main/40.jpg", alias: "Pickleball Sunshine Best Action Shot" },

  // volleyball group
  { path: "main/1.jpg", alias: "--Volleyball Group Sunset--" },
  { path: "main/3.jpg", alias: "Volleyball David Rainbow" },
  { path: "main/34.jpg", alias: "Volleyball Sunset Margaritaville Smiles Game" },
  { path: "main/35.jpg", alias: "Volleyball Sunset Margaritaville Ball Only" },
  {
    path: "main/medium_beach_volleyball_group_20240506a.jpeg",
    alias: "Volleyball - Castaways Beach Day",
  },
  { path: "main/19.jpg", alias: "Volleyball Grass Rainbow" },
  { path: "main/20.jpg", alias: "Volleyball Grass Sunset" },


  // dance
  { path: "main/dance-salsa-havana-nights-002.jpeg", alias: "--Salsa Dance Group Dancing--" },
  { path: "main/7.jpg", alias: "Salsa Dance Group Crazy" },
  { path: "main/country_dance_0002.jpg", alias: "Country Dance Green Cove" },
  { path: "main/30.jpg", alias: "Country Dance Group K1" },

  // other stuff
  { path: "main/41.jpg", alias: "--Ping Pong--" },
  { path: "main/42.jpg", alias: "Bonfire Sunset" },
  { path: "main/43.jpg", alias: "River and Post Friends" },
  { path: "main/44.jpg", alias: "Spanish Group Ruby Brewing" },
  { path: "main/45.jpg", alias: "Missoula Public Library" },
  { path: "main/6.jpg", alias: "Concert Daytime Seawalk" },
  { path: "main/basketball_group_03.jpg", alias: "Basketball Group" },
  { path: "main/church_group_0001.jpg", alias: "Church Group Sign" },
  { path: "main/greenroom_dog_0001.jpg", alias: "Dogs at Brewery" },
  { path: "main/group_pizza_001.jpg", alias: "Group V Pizza" },
  { path: "main/hike_0001.jpg", alias: "Hike Group" },
  { path: "spanish_conversation_0001.jpg", alias: "Spanish Group" },
  { path: "main/rock_climb_001.jpg", alias: "Rock Climbing Edge" },
  { path: "main/rock_climb_beaches_2025April29a.jpg", alias: "Rock Climbing Beaches" },
  { path: "main/18.jpg", alias: "Rock Climbing St Aug" },
  { path: "main/top_golf_0001.jpg", alias: "Golf Driving Range" },
  {
    path: "main/sunrise-beach-worship-ai-01.jpg",
    alias: "Beach Worship or Church",
  },
  { path: "main/12.jpg", alias: "Brewery Hangout Foosball" },
  { path: "main/medium_art_walk_001.jpeg", alias: "Art Walk" },
  { path: "main/bonfire_2024_jan_0001.jpg", alias: "Bonfire Big Group from Above" },
  { path: "main/14.jpg", alias: "Bonfire small group" },
  { path: "main/15.jpg", alias: "Bonfire sand seating" },
  { path: "main/coffee00.jpg", alias: "Coffee Shop" },
  { path: "main/pool_hangout_0001.jpg", alias: "Pool Hangout Group" },
];
